import { useMemo } from "react";
import moment from "moment-timezone";
import { calculateSections } from "../../../../TraxxionSchedule/Component/hooks/form/useInitialValues";

const toWallClockDate = (value) => {
    return value
        ? moment(moment.parseZone(value).format("YYYY-MM-DDTHH:mm:ss")).toDate()
        : undefined;
};

const getIsSimple = (data) => {
    if (typeof data.isSimple === "boolean") {
        return data.isSimple;
    }
    if (data.eventType) {
        return !data.eventType.allowSegmentation;
    }
    return (data.sections?.filter((section) => section?.type !== "break").length || 0) <= 1;
};

export const useInitialValues = ({ data, defaultSection, breaks }) => {
    return useMemo(() => {
        if (!data) {
            return {
                isSimple: true,
                recurrence: null,
                ...defaultSection,
                date: moment(defaultSection?.start).startOf("day").toDate(),
                startDate: defaultSection?.start ? moment(defaultSection.start).toDate() : undefined,
                endDate: defaultSection?.end ? moment(defaultSection.end).toDate() : undefined,
                breaks,
            };
        }
        const { eventType, ...rest } = data;
        const sections = calculateSections({ ...data, startDate: moment.parseZone(data.startDate) });

        return {
            ...rest,
            ...data.sections?.[0],
            isSimple: getIsSimple(data),
            date: moment(data.date).toDate(),
            startDate: toWallClockDate(data.startDate),
            endDate: toWallClockDate(data.endDate),
            sections,
            breaks: sections?.filter((section) => section.type === "break") || [],
        };
    }, [data, defaultSection, breaks]);
};
